import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { Button } from "./ui/button";

// Gestisce il ritorno da Emergent Google Auth: {origin}/dashboard#session_id=...
export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const processed = useRef(false);
  const [errore, setErrore] = useState("");

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const params = new URLSearchParams(location.hash.replace(/^#/, ""));
    const sessionId = params.get("session_id");
    if (!sessionId) { setErrore("Sessione Google mancante: riprova l'accesso."); return; }
    (async () => {
      try {
        const { data } = await api.post("/auth/google/session", { session_id: sessionId });
        if (data.access_token) localStorage.setItem("access_token", data.access_token);
        window.history.replaceState(null, "", window.location.pathname);
        await refresh();
        navigate("/dashboard", { replace: true });
      } catch (e) {
        setErrore(e.response?.data?.detail || "Accesso con Google non riuscito.");
      }
    })();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50" data-testid="auth-callback">
      {errore ? (
        <div className="text-center space-y-3">
          <div className="text-sm text-red-600" data-testid="auth-callback-error">{errore}</div>
          <Button variant="outline" onClick={() => { window.history.replaceState(null, "", "/login"); window.location.assign("/login"); }} data-testid="auth-callback-back-btn">
            Torna all&apos;accesso
          </Button>
        </div>
      ) : (
        <div className="text-sm text-slate-500 font-mono">Accesso con Google in corso…</div>
      )}
    </div>
  );
}
